import React, { Fragment } from "react";
import { PersonNameById } from "../../../sg-hpr/components/persons/PersonName";
import { useApplicationConfiguration } from "../../configuration/ConfigurationContext";
import { ControlledObservationFormFields as ControlledFields, IAuditNoteFormData } from "../../interfaces/IAuditNote";
import moment from "moment";
import IFormType from "../../interfaces/IFormType";
import { FormTypeName } from "../formType/FormTypeName";

interface NoteFormInfoProps {
    formData: IAuditNoteFormData;
    auditFormType: IFormType["id"];
};

export const NoteFormInfo: React.FC<NoteFormInfoProps> = ({
    formData,
    auditFormType
}) => {

    const { components: { LocationName } } = useApplicationConfiguration();

    return (
        <div className="NoteFormInfo">
            <div><strong> <FormTypeName formTypeId={auditFormType} /> </strong></div>
            {/*
            <div>
                {formData.target && (
                    <LocationName locationId={formData.target} />
                )}
            </div>
             */}
            <div>
                {formData.creator && (
                    <PersonNameById personId={formData.creator} />
                )}
            </div>
            <div>
                {formData[ControlledFields.eventTime] && (
                    moment(formData[ControlledFields.eventTime]).format("DD.MM.YYYY")
                )}
            </div>
        </div>
    );
};
